import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { User } from '../auth/auth.types';
import {
  AcceptInvitationPayload,
  CreateInvitationPayload,
  InvitationsResponse,
  InvitationTokenInfo,
} from './invitation.types';

@Injectable({ providedIn: 'root' })
export class InvitationService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api`;

  /** List invitations for an entity (inviter side). */
  list(shortId: string): Observable<InvitationsResponse> {
    return this.http.get<InvitationsResponse>(`${this.base}/entities/${shortId}/invitations/`);
  }

  /** Invite someone to the company; returns the refreshed invitation list. */
  create(shortId: string, payload: CreateInvitationPayload): Observable<InvitationsResponse> {
    return this.http.post<InvitationsResponse>(
      `${this.base}/entities/${shortId}/invitations/`,
      payload,
    );
  }

  /** Cancel a pending invitation. */
  cancel(shortId: string, inviteId: string): Observable<void> {
    return this.http.post<void>(
      `${this.base}/entities/${shortId}/invitations/${inviteId}/cancel/`,
      {},
    );
  }

  /** Pre-accept summary for the invitee's accept page (public). */
  tokenInfo(token: string): Observable<InvitationTokenInfo> {
    return this.http.get<InvitationTokenInfo>(`${this.base}/invitations/info/`, {
      params: new HttpParams().set('token', token),
    });
  }

  /** Accept an invitation; the API signs the user in and returns their profile. */
  accept(payload: AcceptInvitationPayload): Observable<User> {
    return this.http.post<User>(`${this.base}/invitations/accept/`, payload);
  }
}
